module.exports = __webpack_public_path__ + "img/highlight.1ec127d5.svg";